<script lang="ts" setup>
// ヘルプアイコン（モーダル付き）
import SvgLoader from '@/utils/SvgLoader.vue';
import { onMounted, ref, watch } from 'vue';

const result = ref<DOMRect>();
const xLength = ref(0);
const yLength = ref(0);
const isClicked = ref(false);

// ランダムID生成
const imgId = ref<string>('');

const props = withDefaults(
  defineProps<{
    useTransform?: boolean;
  }>(),
  {
    useTransform: false,
  }
);

onMounted(() => {
  imgId.value = Math.random().toString(32).substring(2);
});

watch(
  () => isClicked.value,
  () => {
    if (isClicked.value) {
      const element = document.getElementById(imgId.value);
      if (!element) return;
      result.value = element.getBoundingClientRect();
      xLength.value = result.value.left;
      yLength.value = result.value.bottom;
    }
  }
);
</script>

<template>
  <div class="order-alert-header">
    <SvgLoader :id="imgId" class="order-alert-header__icon" name="questionIcon" @click="isClicked = !isClicked" />
    <Teleport v-if="isClicked" to="body">
      <div
        :style="{
          top: `${yLength}px`,
          left: `${xLength - 25}px`,
          transform: props.useTransform ? `translateX(-100%)` : 'translateX(0%)',
        }"
        class="header-modal"
      >
        <slot />
      </div>
    </Teleport>
  </div>
</template>

<style lang="scss" scoped>
.header-modal {
  padding: 16px 24px;
  background-color: $semanticWhite;
  box-shadow: 0px 0px 22px 0px #80808066;
  position: absolute;
  z-index: 10;
  right: 50px;
  margin-left: 12px;
  border-radius: 8px;

  width: min-content; // 必要に応じて幅を調整
  min-width: 250px; // 最小幅を設定
}
</style>
